
// assign window.__webpack_share_scopes__
(function assignShareScopeToGlobal() {
	try {
		__webpack_require__.d(__webpack_require__.g, {
			__webpack_share_scopes__: () => __webpack_require__.S,
		});
	} catch(e) {}
})();
